// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .container-profile {
    flex: 1;
    background: #fff;
    margin-left: 30px;
    margin-right: 30px;
    height: 108%;
 }

 .sub-menu,
 .sub-menu-signature {
   align-items: center;
   border-bottom: 1px solid #eaeaea;
   padding: 5px 90px 5px 30px;
   display: flex;
   justify-content: space-between;
 }
 
 .sub-menu {
   height: 65px;
 }
 
 .sub-menu-signature {
   height: 81px;
 }

 .sub-menu input {
      border: 1px solid rgba(42, 180, 192, .5);
      border-radius: 2px;
      display: none;
      width: 60%;
      outline: none;
      margin-left: -5px;
      padding: 4px;
      text-align: right;
 }

 .right-element {
    margin-left: auto;
    white-space: nowrap;

  }

  .sub-menu a{
    cursor: pointer;
    margin-left: 30px;
  }

 
.avatar img {
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
 }

 img.invisible {
    opacity: 0;
 }

 .hidden-edit-link {
   visibility: hidden;
 }

 .signature {
    width: 260px;
    min-width: 260px!important;
    height: 70px;
    outline: none;
    border: solid 1px #ccc;
    background-color: white!important;
    overflow: hidden;
    position: relative;
    border-radius: 8px;
    cursor: pointer;
 }
 
 .signature img {
   max-height: 50px;
   max-width: 220px;
}
 

 .initial {
    width: 200px;
    height: 70px;
    outline: none;
    border: solid 1px #ccc;
    background-color: white!important;
    overflow: hidden;
    position: relative;
    border-radius: 8px;
    cursor: pointer;
 }
 .initial img {
   object-fit: contain;
   max-height: 50px;
   max-width: 220px;
}
 
 .sub-menu-label{
   width: 90%;
 }

 .menu-title-text{
   font-size: 20px;
 }

 .edit{
   color: #999;
   vertical-align: middle;
   text-align: center;
   cursor: pointer;
   margin-left: 20px;
   overflow: unset;
}
.edit:hover {
   color: #00bed6;
}

.editing .profile-detail {
   display: none;
}

.editing input {
   display: block;
}
`, "",{"version":3,"sources":["webpack://./src/app/account/profile/general/general.component.css"],"names":[],"mappings":"CAAC;IACG,OAAO;IACP,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;CACf;;CAEA;;GAEE,mBAAmB;GACnB,gCAAgC;GAChC,0BAA0B;GAC1B,aAAa;GACb,8BAA8B;CAChC;;CAEA;GACE,YAAY;CACd;;CAEA;GACE,YAAY;CACd;;CAEA;MACK,wCAAwC;MACxC,kBAAkB;MAClB,aAAa;MACb,UAAU;MACV,aAAa;MACb,iBAAiB;MACjB,YAAY;MACZ,iBAAiB;CACtB;;CAEA;IACG,iBAAiB;IACjB,mBAAmB;;EAErB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;;AAGF;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;CACf;;CAEA;IACG,UAAU;CACb;;CAEA;GACE,kBAAkB;CACpB;;CAEA;IACG,YAAY;IACZ,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;CAClB;;CAEA;GACE,gBAAgB;GAChB,gBAAgB;AACnB;;;CAGC;IACG,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;CAClB;CACA;GACE,mBAAmB;GACnB,gBAAgB;GAChB,gBAAgB;AACnB;;CAEC;GACE,UAAU;CACZ;;CAEA;GACE,eAAe;CACjB;;CAEA;GACE,WAAW;GACX,sBAAsB;GACtB,kBAAkB;GAClB,eAAe;GACf,iBAAiB;GACjB,eAAe;AAClB;AACA;GACG,cAAc;AACjB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,cAAc;AACjB","sourcesContent":[" .container-profile {\n    flex: 1;\n    background: #fff;\n    margin-left: 30px;\n    margin-right: 30px;\n    height: 108%;\n }\n\n .sub-menu,\n .sub-menu-signature {\n   align-items: center;\n   border-bottom: 1px solid #eaeaea;\n   padding: 5px 90px 5px 30px;\n   display: flex;\n   justify-content: space-between;\n }\n \n .sub-menu {\n   height: 65px;\n }\n \n .sub-menu-signature {\n   height: 81px;\n }\n\n .sub-menu input {\n      border: 1px solid rgba(42, 180, 192, .5);\n      border-radius: 2px;\n      display: none;\n      width: 60%;\n      outline: none;\n      margin-left: -5px;\n      padding: 4px;\n      text-align: right;\n }\n\n .right-element {\n    margin-left: auto;\n    white-space: nowrap;\n\n  }\n\n  .sub-menu a{\n    cursor: pointer;\n    margin-left: 30px;\n  }\n\n \n.avatar img {\n    border: none;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n }\n\n img.invisible {\n    opacity: 0;\n }\n\n .hidden-edit-link {\n   visibility: hidden;\n }\n\n .signature {\n    width: 260px;\n    min-width: 260px!important;\n    height: 70px;\n    outline: none;\n    border: solid 1px #ccc;\n    background-color: white!important;\n    overflow: hidden;\n    position: relative;\n    border-radius: 8px;\n    cursor: pointer;\n }\n \n .signature img {\n   max-height: 50px;\n   max-width: 220px;\n}\n \n\n .initial {\n    width: 200px;\n    height: 70px;\n    outline: none;\n    border: solid 1px #ccc;\n    background-color: white!important;\n    overflow: hidden;\n    position: relative;\n    border-radius: 8px;\n    cursor: pointer;\n }\n .initial img {\n   object-fit: contain;\n   max-height: 50px;\n   max-width: 220px;\n}\n \n .sub-menu-label{\n   width: 90%;\n }\n\n .menu-title-text{\n   font-size: 20px;\n }\n\n .edit{\n   color: #999;\n   vertical-align: middle;\n   text-align: center;\n   cursor: pointer;\n   margin-left: 20px;\n   overflow: unset;\n}\n.edit:hover {\n   color: #00bed6;\n}\n\n.editing .profile-detail {\n   display: none;\n}\n\n.editing input {\n   display: block;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
